import { useTranslation } from 'react-i18next';
import 'bootstrap/dist/css/bootstrap.min.css';
import "./developmentprocess.css"

function DevelopmentProcess() {
  const { t } = useTranslation();
  return (
    <section style={{ width: "91.5vw", margin: "auto", paddingTop: "100px" }} aria-labelledby="about-heading">
      <div className='developmentprocess-section'>
        <h1 id="about-heading" className="our-stories">{t("howwework")}</h1>
        <p className='about-us-description'>
          {t("aboutuspagedescription")}
        </p>
      </div>
    </section>
  )
}

export default DevelopmentProcess
